
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'SuperUpClass',
  components: {
  },
})
export default class SuperUpClass extends Vue {
}
